module.exports = __webpack_public_path__ + "img/programmer-and-coding-concept.5dbcb3c2.webp";